import {createStore, shelves, figureShelves} from './bj3d-rewards-742669a9bf79-store.js';
import {catalog, figures} from './bj3d-6e0fb77bb377-catalog.js';
import {ShopifyCommerce, needsVariantChoice, visibleVariantTitle} from './bj3d-6e0fb77bb377-commerce.js';
import {createAnalytics} from './bj3d-6e0fb77bb377-analytics.js';

const config = JSON.parse(document.getElementById('bj3d-config').textContent);
config.root = config.root.replace(/\/?$/, '/');
const t = key => config.text[key] || key;
const $ = id => document.getElementById(id);
const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const commerce = new ShopifyCommerce({root:config.root, origin:location.origin});
const states = new Map();
let store, currentCategory = 0, selected = null, sequence = 0, cartState = null;
const picture = (src, name) => `<img class="product-photo" src="${escape(src)}" alt="${escape(name)}" loading="lazy" decoding="async">`;
const livePrice = p => {
  if (!p.handle) return t('display_only');
  const state = states.get(p.id);
  if (!state) return t('checking');
  if (state.error) return t('unavailable');
  if (!state.product.available) return t('sold_out');
  return (state.product.price_varies ? t('from') + ' ' : '') + commerce.format(state.product.price_min);
};
const event = createAnalytics({designMode: config.designMode});
function productUrl(p) { return config.root + 'products/' + encodeURIComponent(p.handle); }
function showCategory(category, move = true) {
  currentCategory = category;
  $('catalogTitle').textContent = shelves[category].name;
  $('catalogHint').textContent = t('live_note');
  $('figureShelfNav').hidden = category < 5;
  if (category >= 5) {
    $('figureShelfNav').innerHTML = shelves.slice(5).map((s,i) => `<button data-snack="${i+5}" aria-pressed="${category === i+5}">${escape(s.name)}</button>`).join('');
    $('figureShelfNav').querySelectorAll('button').forEach(b => b.onclick = () => showCategory(Number(b.dataset.snack)));
  }
  $('shelfSelect').value = category >= 5 ? 'snacks' : String(category);
  document.querySelectorAll('[data-category]').forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.category) === category)));
  $('snackNav').setAttribute('aria-pressed', String(category >= 5));
  $('products').innerHTML = catalog.filter(p => p.category === category).map(p => `<button class="product-card" data-product="${p.id}"><span class="card-photo">${picture(safeImage(states.get(p.id)?.product?.featured_image) || p.photo.localSrc,p.name)}</span><b>${escape(states.get(p.id)?.product?.title || p.name)}</b><small>${escape(livePrice(p))}</small></button>`).join('');
  $('products').querySelectorAll('[data-product]').forEach(b => b.onclick = () => select(Number(b.dataset.product)));
  if (move) store?.visit(category);
}
function showFigures(move = true, shelf = null) {
  if (!figures.length) return;
  currentCategory = 'figures';
  $('catalogTitle').textContent = t('figures'); $('catalogHint').textContent = t('not_registered');
  $('shelfSelect').value = 'figure';
  $('figureShelfNav').hidden = false;
  $('snackNav').setAttribute('aria-pressed','false'); $('figureNav').setAttribute('aria-pressed','true');
  document.querySelectorAll('[data-category]').forEach(b => b.setAttribute('aria-pressed','false'));
  $('figureShelfNav').innerHTML = figureShelves.map(s => `<button data-shelf="${s.index}" aria-pressed="${shelf === s.index}">${escape(t('figure_shelf'))} ${s.index + 1}</button>`).join('');
  $('figureShelfNav').querySelectorAll('button').forEach(b => b.onclick = () => showFigures(true,Number(b.dataset.shelf)));
  $('products').innerHTML = figures.map((f,i) => shelf !== null && f.shelf !== shelf ? '' : `<button class="product-card" data-figure="${i}"><span class="card-photo">${picture(f.image,f.title)}</span><b>${escape(f.title)}</b><small>${escape(f.edition)}</small><small>${escape(t('display_only'))}</small></button>`).join('');
  $('products').querySelectorAll('button').forEach(b => b.onclick = () => selectFigure(Number(b.dataset.figure)));
  if (move) store?.visitFigure(shelf ?? 0,false);
}
function openDetails() {
  if ($('basket').open) $('basket').close();
  if (!$('productDialog').open) $('productDialog').showModal();
}
function displayOnly(name, image, needsReview = false) {
  selected = null; ++sequence;
  $('detail').innerHTML = `<div class="product-modal-grid"><div class="product-visual">${picture(image,name)}</div><div><h2 id="productTitle">${escape(name)}</h2><p>${escape(t(needsReview ? 'identity_check' : 'not_registered'))}</p><p>${escape(t('display_only'))}</p></div></div>`;
  openDetails();
}
function selectFigure(index) {
  const f = figures[index]; if (f) displayOnly(f.title + ' — ' + f.edition, f.image, f.needsCodeReview);
}
async function select(id) {
  const p = catalog.find(p => p.id === id); if (!p) return;
  if (!p.handle) return displayOnly(p.name, p.photo.localSrc);
  selected = p; const ticket = ++sequence;
  $('detail').innerHTML = `<h2 id="productTitle">${escape(p.name)}</h2><p role="status">${escape(t('checking'))}</p>`;
  openDetails();
  try {
    await commerce.cart();
    const product = await commerce.product(p.handle, p.productId);
    states.set(p.id,{product}); store?.refreshProductLabels([p.id]);
    if (ticket !== sequence) return;
    renderProduct(p,product);
    event('view_item',{item_id:String(product.id),currency:commerce.currency});
  } catch {
    if (ticket !== sequence) return;
    states.set(p.id,{error:true}); store?.refreshProductLabels([p.id]);
    $('detail').innerHTML = `<h2 id="productTitle">${escape(p.name)}</h2><p>${escape(t('unavailable'))}</p><a href="${escape(productUrl(p))}">${escape(t('product_page'))}</a>`;
  }
}
function renderProduct(p, product) {
  const variants = product.variants;
  const defaultVariant = variants.find(v => v.available) || variants[0];
  const image = safeImage(product.featured_image) || p.photo.localSrc;
  $('detail').innerHTML = `<div class="product-modal-grid"><div class="product-visual">${picture(image,product.title)}</div><div class="product-copy"><h2 id="productTitle">${escape(product.title)}</h2><p>${escape(product.vendor)}</p><a href="${escape(productUrl(p))}">${escape(t('product_page'))}</a><p class="sample-note">${escape(t('shape_note'))}</p><label for="variant">${escape(t('variant'))}</label><select id="variant">${variants.map(v => `<option value="${v.id}" ${v.id === defaultVariant?.id ? 'selected' : ''} ${v.available ? '' : 'disabled'}>${escape(v.title)} · ${escape(commerce.format(v.price))}${v.available ? '' : ' · ' + escape(t('sold_out'))}</option>`).join('')}</select><p class="price" id="livePrice"></p><p id="availability"></p></div></div><div class="product-actions"><label for="qty">${escape(t('quantity'))}</label><input id="qty" type="number" min="1" max="99" step="1" value="1" inputmode="numeric"><button id="add" class="primary">${escape(t('add'))}</button><p id="addedStatus" role="status" aria-live="polite"></p><button id="productViewCart">${escape(t('view_cart'))}</button></div>`;
  let displayedCurrency = commerce.currency;
  const shippingNote = document.createElement('p');
  shippingNote.className = 'shipping-note';
  shippingNote.textContent = t('shipping_note');
  $('availability').after(shippingNote);
  const variantPicker = $('variant');
  if (!needsVariantChoice(product)) {
    variantPicker.previousElementSibling.remove();
    variantPicker.remove();
  }
  const chosen = () => needsVariantChoice(product) ? variants.find(v => v.id === Number(variantPicker.value)) : defaultVariant;
  function variantChanged() {
    const v = chosen();
    const allowed = product.available && v?.available && !product.requires_selling_plan && !v.requires_selling_plan;
    $('livePrice').textContent = v ? commerce.format(v.price) : '';
    $('availability').textContent = t(allowed ? 'available' : 'use_product_page');
    $('add').disabled = !allowed;
  }
  variantPicker.onchange = variantChanged; variantChanged();
  $('productViewCart').onclick = openCart;
  $('add').onclick = async () => {
    const v = chosen(), quantity = Number($('qty').value), ticket = sequence;
    if (!v || !Number.isInteger(quantity) || quantity < 1 || quantity > 99) { $('addedStatus').textContent = t('invalid_quantity'); return; }
    $('add').disabled = true; $('addedStatus').textContent = t('adding');
    try {
      await commerce.add({handle:p.handle,productId:product.id,variantId:v.id,quantity,expectedPrice:v.price,expectedCurrency:displayedCurrency});
      if (ticket === sequence) $('addedStatus').textContent = t('added');
      event('add_to_cart',{item_id:String(product.id),item_variant:String(v.id),quantity,currency:displayedCurrency,value:v.price * quantity / 100});
    } catch (error) {
      if (ticket === sequence) $('addedStatus').textContent = t(error.code === 'PRICE_CHANGED' ? 'price_changed' : 'add_failed');
    } finally {
      await refreshCart();
      if (ticket === sequence) {
        $('add').disabled = false;
        $('add').textContent = t('refresh_product');
        $('add').onclick = () => select(p.id);
      }
    }
  };
}
function safeImage(value) {
  if (!value) return null;
  try { const url = new URL(value,location.origin); return ['https:','http:'].includes(url.protocol) ? url.href : null; } catch { return null; }
}
async function refreshCart() {
  try {
    cartState = await commerce.cart();
    cartState.items = cartState.items.map(item => ({...item,variant_title:visibleVariantTitle(item.variant_title)}));
    $('count').textContent = cartState.item_count;
    $('total').textContent = commerce.format(cartState.total_price);
    $('registerTotal').textContent = commerce.format(cartState.total_price);
    $('registerCount').textContent = `${cartState.item_count} ${t('items')}`;
    $('cartItems').innerHTML = cartState.items.map(item => `<div class="cart-row">${safeImage(item.image) ? picture(safeImage(item.image),item.product_title) : ''}<div><b>${escape(item.product_title)}</b><p>${escape(item.variant_title || '')}</p><small>${item.quantity} × ${escape(commerce.format(item.final_price))}</small></div><strong>${escape(commerce.format(item.final_line_price))}</strong></div>`).join('') || `<p>${escape(t('empty_cart'))}</p>`;
    $('registerItems').textContent = cartState.items.map(i => `${i.product_title} × ${i.quantity}`).join(' · ') || t('empty_cart');
    const entries = new Map();
    for (const item of cartState.items) {
      const p = catalog.find(p => states.get(p.id)?.product?.id === item.product_id);
      if (p) entries.set(p.id,(entries.get(p.id) || 0) + item.quantity);
    }
    store?.syncCart([...entries].map(([id,quantity]) => ({id,quantity})),[],{count:cartState.item_count,total:commerce.format(cartState.total_price)});
    $('confirmation').textContent = ''; return true;
  } catch {
    $('confirmation').textContent = t('cart_failed'); return false;
  }
}
async function openCart() {
  if ($('productDialog').open) $('productDialog').close();
  if (!$('basket').open) $('basket').showModal();
  await refreshCart();
}
$('closeProduct').onclick = () => { ++sequence; selected = null; $('productDialog').close(); };
$('productDialog').addEventListener('cancel',() => { ++sequence; selected = null; });
$('closeCart').onclick = () => $('basket').close();
$('cartButton').onclick = openCart;
$('checkout').href = config.cartUrl;
$('checkout').onclick = () => event('cart_handoff');
document.querySelectorAll('[data-category]').forEach(b => b.onclick = () => showCategory(Number(b.dataset.category)));
$('snackNav').onclick = () => showCategory(5);
$('shelfSelect').onchange = e => showCategory(e.target.value === 'snacks' ? 5 : Number(e.target.value));
$('enter').onclick = () => store?.enter(); $('entranceView').onclick = () => store?.entrance();
$('registerView').onclick = () => store?.register(); $('reviewRegister').onclick = openCart;
$('doorToggle').onclick = () => store?.toggleDoor();
try {
  store = createStore({rewardPreview:config.designMode === true,viewport:$('viewport'),catalog,figures,onSelect:select,onVisit:c => showCategory(c,false),onCheckout:openCart,onFigureSelect:selectFigure,onFigureVisit:i => showFigures(false,i),productPriceLabel:livePrice,figurePriceLabel:() => t('display_only'),figureStatus:t('not_registered')});
  $('loading').remove();
} catch { $('loading').textContent = t('no_3d'); }
showCategory(0,false);
event('enter_store');
async function loadPrices() {
  if (!await refreshCart()) return;
  const queue = catalog.filter(p => p.handle);
  await Promise.all(Array.from({length:2},async () => {
    while (queue.length) {
      const p = queue.shift();
      try { states.set(p.id,{product:await commerce.product(p.handle, p.productId)}); }
      catch { if (!states.get(p.id)?.product) states.set(p.id,{error:true}); }
      store?.refreshProductLabels([p.id]);
      if (currentCategory === p.category) showCategory(currentCategory,false);
      await new Promise(resolve => setTimeout(resolve,750));
    }
  }));
  await refreshCart();
}
loadPrices();
window.addEventListener('pageshow',e => { if (e.persisted) { states.clear(); store?.refreshProductLabels(); loadPrices(); } });
document.addEventListener('visibilitychange',() => { if (!document.hidden) { refreshCart(); if (selected && $('productDialog').open) select(selected.id); } });
